import Login from "@/components/Auth/Login";
import Heading from "../components/Heading";

const LoginCheckout = ({goToLoginCheckout, setCheckoutData }: { setCheckoutData: () => void, goToLoginCheckout: () => void}) => {
  return (
    <>
      <Heading title="Log in" mb={{ xs: 2, md: 1 }} />
      <Login goToLoginCheckout={goToLoginCheckout} setCheckoutData={setCheckoutData} />
    </>
  );
};

export default LoginCheckout;
